// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"c97cda51","175":"bb5269db","371":"8c45336f","884":"a1fa906f"}[chunkId] + ".chunk.css";
};